// extracted by mini-css-extract-plugin
export default {"root":"filterElementWrap_root__MGBl8"};